<ng-container *ngIf="$selectImportDwsmConfig | async"></ng-container>
<div
    class="dwsm-settings"
    [formGroup]="dwsmForm">
    <div class="dwsm-settings__form">
        <div class="dwsm-settings__form__column">
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [maxFractionDigits]="2"
                    [autoWidth]="true"
                    [styleFloatLabel]="updateFormClasses('shiftTime')"
                    inputId="shiftTime"
                    formControlName="shiftTime"
                    label="{{ 'DWSM_EXPERT_MENU_SHIFT_TIME_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_MINUTE_UNIT.TXT' | translate }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('minWalkingSpeed')"
                    formControlName="minWalkingSpeed"
                    label="{{ 'DWSM_EXPERT_MENU_MIN_WALKING_SPEED_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_METER_PER_SECOND_UNIT.TXT' | translate }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('minFastWalkingSpeed')"
                    formControlName="minFastWalkingSpeed"
                    label="{{ 'DWSM_EXPERT_MENU_MIN_FAST_WALKING_SPEED_ANGULAR.TXT' | translate }} ({{
                        'DWSM_EXPERT_MENU_METER_PER_SECOND_UNIT.TXT' | translate
                    }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('minForceTime')"
                    formControlName="minForceTime"
                    label="{{ 'DWSM_EXPERT_MENU_MIN_FORCE_TIME_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_MILLISECOND_UNIT.TXT' | translate }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('minForceDetection')"
                    formControlName="minForceDetection"
                    label="{{ 'DWSM_EXPERT_MENU_MIN_FORCE_DETECTION_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_NEWTON_UNIT.TXT' | translate }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
        </div>
        <div class="dwsm-settings__form__column">
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('outlierDetectionFactor')"
                    formControlName="outlierDetectionFactor"
                    [label]="'DWSM_EXPERT_MENU_OUTLIER_DETECTION_FACTOR_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('smoothingQuarternions')"
                    formControlName="smoothingQuarternions"
                    [label]="'DWSM_EXPERT_MENU_SMOOTHING_QUARTERNIONS_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('smoothingPositions')"
                    formControlName="smoothingPositions"
                    [label]="'DWSM_EXPERT_MENU_SMOOTHING_POSITIONS_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
        </div>
        <div class="dwsm-settings__form__column dwsm-settings__form__column--with-header">
            <p class="sera__subtitle">{{ 'DWSM_EXPERT_MENU_SNAP-IN_DETECTION.TXT' | translate | uppercase }}</p>

            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('accelerationThreshold')"
                    formControlName="accelerationThreshold"
                    label="{{ 'DWSM_EXPERT_MENU_ACCELERATION_THRESHOLD_ANGULAR.TXT' | translate }} ({{
                        'DWSM_EXPERT_MENU_NEWTON_PER_SEC_SQUARED_UNIT.TXT' | translate
                    }})"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('stepsToTrough')"
                    formControlName="stepsToTrough"
                    [label]="'DWSM_EXPERT_MENU_STEPS_TO_TROUGH_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('stepsToPeak')"
                    formControlName="stepsToPeak"
                    [label]="'DWSM_EXPERT_MENU_STEPS_TO_PEAK_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('stepsAfterThreshold')"
                    formControlName="stepsAfterThreshold"
                    [label]="'DWSM_EXPERT_MENU_STEPS_AFTER_THRESHOLD_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
            <div class="dwsm-settings__form__column__element">
                <sera-input-number
                    [min]="0"
                    [autoWidth]="true"
                    [maxFractionDigits]="2"
                    [styleFloatLabel]="updateFormClasses('correction')"
                    formControlName="correction"
                    [label]="'DWSM_EXPERT_MENU_CORRECTION_ANGULAR.TXT' | translate"
                    [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
                </sera-input-number>
            </div>
        </div>
    </div>
    <div class="dwsm-settings__form__column dwsm-settings__form__column--own-row">
        <div class="dwsm-settings__form__column__element dwsm-settings__form__column__element--factor">
            <sera-input-number
                [min]="0"
                [autoWidth]="true"
                [maxFractionDigits]="2"
                [isDisabled]="isFactorDynNeckStressDisabled()"
                [styleFloatLabel]="updateFormClasses('factorDynNeckStress')"
                formControlName="factorDynNeckStress"
                label="{{ 'DWSM_EXPERT_MENU_FACTOR_DYN_NECK_STRESS_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_SECOND_UNIT.TXT' | translate }})"
                [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
            </sera-input-number>
            <sera-checkbox
                formControlName="noFactor"
                [label]="'DWSM_EXPERT_MENU_NO_FACTOR.TXT' | translate"
                (stateChanged)="onNoFactorChange()">
            </sera-checkbox>
        </div>
        <div class="dwsm-settings__form__column__element">
            <sera-input-number
                [min]="0"
                [autoWidth]="true"
                [maxFractionDigits]="2"
                [styleFloatLabel]="updateFormClasses('minHandMoveCR07')"
                formControlName="minHandMoveCR07"
                label="{{ 'DWSM_EXPERT_MENU_MIN_HAND_MOVE_CR07_ANGULAR.TXT' | translate }} ({{ 'DWSM_EXPERT_MENU_METER_UNIT.TXT' | translate }})"
                [placeholder]="'PAGE.MM_13.RISK_VALUE.LBL' | translate">
            </sera-input-number>
        </div>
    </div>
    <div class="dwsm-settings__form__footer">
        <sera-button
            [loading]="($selectDwsmOverviewIsLoading | async)!"
            [isDisabled]="dwsmForm.invalid"
            class="sera-outline-button"
            [label]="'DWSM_EXPERT_MENU_BUTTON_SET_PERSONAL_DEFAULTS.TXT'"
            (buttonClick)="onSetPersonalDwsmGlobalConfig()">
        </sera-button>
        <sera-button
            [loading]="($selectDwsmOverviewIsLoading | async)!"
            class="sera-outline-button"
            [label]="'DWSM_EXPERT_MENU_BUTTON_RELOAD_GLOBAL_DEFAULTS.TXT'"
            (buttonClick)="onLoadGlobalDwsmGlobalConfig()">
        </sera-button>
        <sera-button
            [isDisabled]="dwsmForm.invalid"
            [loading]="($selectDwsmOverviewIsLoading | async)!"
            class="sera-outline-button"
            [label]="'DWSM_EXPERT_MENU_BUTTON_REANALYZE.TXT'"
            (buttonClick)="onReAnalyzeWithCurrentInputs()">
        </sera-button>
    </div>
</div>
